angular.module 'zc.commonApi'

.factory 'CampaignTemplate', ($q, Api) ->
  class CampaignTemplate
    @views: (params) ->
      $q (resolve, reject) ->
        Api.post "/api/projects/#{params.project_id}/campaigns/#{params.campaign_id}/#{params.campaign_type.toLowerCase()}s/#{params.template_type}/views", params
        .then (res) ->
          resolve res.data.views
        , (err) ->
          reject err

    @css: (params) ->
      $q (resolve, reject) ->
        Api.post "/api/projects/#{params.project_id}/campaigns/#{params.campaign_id}/#{params.campaign_type.toLowerCase()}s/#{params.template_type}/css", params
        .then (res) ->
          resolve res.data.css
        , (err) ->
          reject err

    @confirmCss: (params) ->
      $q (resolve, reject) ->
        Api.post "/api/projects/#{params.project_id}/campaigns/#{params.campaign_id}/#{params.campaign_type.toLowerCase()}s/#{params.template_type}/confirm_css", params
        .then (res) ->
          resolve res.data.css
        , (err) ->
          reject err

    @confirmJs: (params) ->
      $q (resolve, reject) ->
        Api.post "/api/projects/#{params.project_id}/campaigns/#{params.campaign_id}/#{params.campaign_type.toLowerCase()}s/#{params.template_type}/confirm_js", params
        .then (res) ->
          resolve res.data.js
        , (err) ->
          reject err



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/campaign_template.service.coffee